import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";
import { Save, ArrowLeft } from "lucide-react";

function AddAsset() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    asset_name: "",
    line: "",
    custom_line: "",
    machine_type: "",
    custom_machine_type: "",
    description: "",
  });

  const lines = [
    "Line A","Line B","Line C","Line D","Shirataki","Juten","1Gal","Fryer",
    "Multivac","Building","Production","SQF","Okara","Recieving","Soaking",
    "Casing","Other"
  ];

  const machines = [
    "Silo","Scale unit","Conveyor","Grinder","Cooker","surge Tank","Separator",
    "Turn Table","Steam Tunnel","Morikomi","Traverser","Press Machine","Alkali CV",
    "Pasteurizer","Automation","Topia","Scal","DPX","Boil&cool","Metal Detector",
    "Taper Machine","Packing Machine","Boiler","Compressor","Chiller",
    "Cooling tower","HVAC","Cooler","Other"
  ];

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      line: formData.line === "Other" ? formData.custom_line : formData.line,
      machine_type:
        formData.machine_type === "Other"
          ? formData.custom_machine_type
          : formData.machine_type,
    };
      api.post("/api/assets", dataToSend)
      .then(() => {
        alert("✅ Asset created successfully!");
        navigate("/assets");
      })
      .catch((err) => {
        console.error("Error creating asset", err);
        alert("❌ Failed to create asset");
      });
  };

  return (
    <div className="main-content">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 24,
        }}
      >
        <h1>➕ Add New Asset</h1>

        {/* Back button */}
        <button
          type="button"
          className="icon-btn ghost"
          onClick={() => navigate("/assets")}
          title="Back to Assets"
        >
          <ArrowLeft size={16} />
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Asset name */}
        <div>
          <label>Asset Name</label>
          <input
            type="text"
            name="asset_name"
            value={formData.asset_name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Line */}
        <div>
          <label>Line</label>
          <select
            name="line"
            value={formData.line}
            onChange={handleChange}
            required
          >
            <option value="">Select Line</option>
            {lines.map((l) => (
              <option key={l} value={l}>
                {l}
              </option>
            ))}
          </select>

          {formData.line === "Other" && (
            <div>
              <label>Custom Line Name</label>
              <input
                type="text"
                name="custom_line"
                value={formData.custom_line}
                onChange={handleChange}
                placeholder="Enter new line name"
                required
              />
            </div>
          )}
        </div>

        {/* Machine type */}
        <div>
          <label>Machine Type</label>
          <select
            name="machine_type"
            value={formData.machine_type}
            onChange={handleChange}
            required
          >
            <option value="">Select Machine</option>
            {machines.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          {formData.machine_type === "Other" && (
            <div>
              <label>Custom Machine Type</label>
              <input
                type="text"
                name="custom_machine_type"
                value={formData.custom_machine_type}
                onChange={handleChange}
                placeholder="Enter new machine type"
                required
              />
            </div>
          )}
        </div>

        {/* Description */}
        <div>
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            gap: 12,
            marginTop: 24,
            alignItems: "center",
          }}
        >
          <button type="submit" className="add-button">
            <Save size={16} />
            Submit Asset
          </button>

          <button
            type="button"
            className="button-secondary"
            onClick={() => navigate("/assets")}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddAsset;
